import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

import { environment } from './environments/environment';

function applyRuntimeConfig(config: any): void {
  environment.config = config.config ?? environment.config;
}
function bootstrapApp() {
  return bootstrapApplication(App, appConfig);
}
function start(): void {
  fetch('assets/config/config.json')
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Config load failed (${response.status})`);
      }
      return response.json();
    })
    .then((config) => applyRuntimeConfig(config))
    .catch((error) => {
      console.error('Failed to load runtime config; falling back to built-in environment', error);
    })
    .then(() => {
      return bootstrapApp();
    })
    .catch((err) => console.error(err));
}

start();
